/**
 * Get the name
 *
 * @param {string} name
 *
 * @returns {string}
 */

export default function humanizeString(name, lowercase = false) {
  if (typeof name !== 'string') return name;

  const cleaned = name
    .replace(/^[\s_]+|[\s_]+$/g, '')  // Trim leading/trailing underscores/spaces
    .replace(/[_\s\-]+/g, ' ')        // Replace _ or - or multiple spaces with single space
    .toLowerCase();

  return lowercase ? cleaned : (cleaned.charAt(0).toUpperCase() + cleaned.slice(1));
}
